import { render, staticRenderFns } from "./PayrollBasicReceiver.vue?vue&type=template&id=a63fac1c&scoped=true&"
import script from "./PayrollBasicReceiver.vue?vue&type=script&lang=js&"
export * from "./PayrollBasicReceiver.vue?vue&type=script&lang=js&"
import style0 from "./PayrollBasicReceiver.vue?vue&type=style&index=0&id=a63fac1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63fac1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a63fac1c')) {
      api.createRecord('a63fac1c', component.options)
    } else {
      api.reload('a63fac1c', component.options)
    }
    module.hot.accept("./PayrollBasicReceiver.vue?vue&type=template&id=a63fac1c&scoped=true&", function () {
      api.rerender('a63fac1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollBasicReceiver.vue"
export default component.exports